// NOTE @chris this is from `parse-numeric-range` npm package, added a small fix to always return numbers
export const rangeParser = (string: string): Array<number> => {
  const res: Array<number> = [];
  let m;

  for (const str of string.split(',').map((str) => str.trim())) {
    // just a number
    if (/^-?\d+$/.test(str)) {
      res.push(parseInt(str, 10));
    } else if (
      (m = str.match(/^(-?\d+)(-|\.\.\.?|\u2025|\u2026|\u22EF)(-?\d+)$/))
    ) {
      let [_, lhs, sep, rhs] = m as any;

      if (lhs && rhs) {
        lhs = parseInt(lhs);
        rhs = parseInt(rhs);
        const incr = lhs < rhs ? 1 : -1;

        if (sep === '-' || sep === '..' || sep === '\u2025') rhs += incr;

        for (let i = lhs; i !== rhs; i += incr) res.push(parseInt(i));
      }
    }
  }

  return res;
};
